<template>
  <div id="app" class="qazlatyn-app">
    <converter-rtl-layout v-if="$route.params.ln === 'tote' && $route.path.includes('/converter')">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </converter-rtl-layout>
    <converter-layout v-else-if="$route.path.includes('/converter')">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </converter-layout>
    <main-rtl-layout v-else-if="$route.params.ln === 'tote'">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </main-rtl-layout>
    <main-layout v-else>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </main-layout>
    <back-to-top class="scroll-to-top"
      v-scroll-to="{
        el: '#app'
      }">
      <a href="#" class="to-top-link">
        <i class="up-icon fal fa-arrow-up"></i>
      </a>
    </back-to-top>
    <notifications
      group="qazlatyn"
      :position="$route.params.ln === 'tote' ? 'top left' : 'top right'"
      :classes="$route.params.ln === 'tote' ? 'qazlatyn-rtl-notifications' : 'qazlatyn-notifications'"
      :max="1" />
    <b-modal class="suggest-modal" ref="reportsuggest" hide-footer :title="ls_ReportError">
      <b-container fluid>
        <b-row class="mb-3">
          <b-col cols="12">
            <h5 class="suggest-label">URL</h5>
            <b-form-input size="sm" class="suggest-input" :value="modalInfo.baseURI" type="text" disabled></b-form-input>
          </b-col>
          <b-col cols="12">
            <h5 class="suggest-label">{{ ls_Error }}</h5>
            <b-form-textarea
              v-model="modalInfo.selectedText"
              :rows="3"
              :max-rows="6"
              class="suggest-textarea">
            </b-form-textarea>
          </b-col>
          <b-col cols="12">
            <h5 class="suggest-label">{{ ls_Opinion }}</h5>
            <b-form-textarea
              v-model="modalInfo.suggestText"
              :rows="3"
              :max-rows="6"
              class="suggest-textarea">
            </b-form-textarea>
          </b-col>
          <b-col cols="12">
            <b-button class="suggest-send-btn" @click="sendSuggest" size="sm" :disabled="disabled">
              {{ ls_Send }}
            </b-button>
            <b-alert class="mt-3" :variant="alertStatus" :show="showStatus">{{ statusText }}</b-alert>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import MainRtlLayout from "@/layouts/MainRtlLayout.vue";
import ConverterLayout from "@/layouts/ConverterLayout.vue";
import ConverterRtlLayout from "@/layouts/ConverterRtlLayout.vue";

export default {
  data() {
    return {
      showStatus: false,
      alertStatus: "success",
      statusText: "Success",
      disabled: false,
      modalInfo: {
        suggestText: "",
        selectedText: "",
        baseURI: ""
      }
    };
  },

  components: {
    "main-layout": MainLayout,
    "main-rtl-layout": MainRtlLayout,
    "converter-layout": ConverterLayout,
    "converter-rtl-layout": ConverterRtlLayout
  },

  mounted() {
    this.$el.parentElement.addEventListener("keydown", e => {
      let ev = e ? e : window.event;
      let keyCode = ev.keyCode ? ev.keyCode : ev.which;
      if (keyCode === 13 && ev.ctrlKey) {
        this.showModal();
      }
    });
  },

  methods: {
    reportSuggest() {
      let selectedNode = window.getSelection();
      this.modalInfo.baseURI = selectedNode.baseNode.baseURI;
      this.modalInfo.selectedText = selectedNode.toString();
    },
    showModal() {
      this.reportSuggest();

      if (
        this.$refs.reportsuggest &&
        this.modalInfo.selectedText !== null &&
        this.modalInfo.selectedText !== ""
      ) {
        this.$refs.reportsuggest.show();
      }
    },
    hideModal() {
      if (this.$refs.reportsuggest) {
        this.$refs.reportsuggest.hide();
      }
    },
    sendSuggest() {
      let timeOut = null;

      if (timeOut) {
        clearTimeout(timeOut);
      }

      this.disabled = true;

      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("url", this.modalInfo.baseURI);
      fd.append("errorText", this.modalInfo.selectedText);
      fd.append("trueText", this.modalInfo.suggestText);
      this.$http
        .post(this.host + "/api/qazlatyn/reportsuggest", fd)
        .then(result => {
          this.disabled = false;
          if (result.status === 200) {
            this.showStatus = true;
            this.alertStatus = result.body.status === "success" ? "success" : "danger";
            this.statusText = result.body.message;

            timeOut = setTimeout(() => {
              if (result.body.status === "success") {
                this.modalInfo.baseURI = "";
                this.modalInfo.selectedText = "";
                this.modalInfo.suggestText = "";
                this.statusText = "";
                this.showStatus = false;
                this.disabled = false;
                this.hideModal();
              }
            }, 2500);
          } else {
            // console.log('Err');
          }
        });
    }
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    ls_Send() {
      return this.$store.state.languagePack.ls_Send;
    },
    ls_ReportError() {
      return this.$store.state.languagePack.ls_ReportError;
    },
    ls_Opinion() {
      return this.$store.state.languagePack.ls_Opinion;
    },
    ls_Error() {
      return this.$store.state.languagePack.ls_Error;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/mixins.scss";

.suggest-modal {
  .suggest-label {
    margin-bottom: 15px;
    color: #212525;
  }

  .suggest-input {
    margin-bottom: 25px;
  }

  .suggest-textarea {
    margin-bottom: 25px;
  }

  .suggest-send-btn {
    background-color: #008490;
    border-color: #008490;

    &:hover {
      background-color: #017580;
      border-color: #008490;
    }
  }
}
.qazlatyn-notifications {
  padding: 10px;
  margin: 0 5px 5px;
  font-size: 12px;
  color: #ffffff !important;
  background: #01c0d1 !important;
  border-left: 5px solid #008490 !important;

  &.warn {
    background: #ffb648 !important;
    border-left-color: #f48a06 !important;
  }

  &.error {
    background: #e54d42 !important;
    border-left-color: #b82e24 !important;
  }

  &.success {
    background: #68cd86 !important;
    border-left-color: #42a85f !important;
  }
}

@include keyframes(loading) {
  0% {
    transform: scaleX(0);
    transform-origin: 0 0;
  }
  50% {
    transform: scaleX(1);
    transform-origin: 0 0;
  }
  51% {
    transform-origin: 100% 0;
  }
  100% {
    transform: scaleX(0);
    transform-origin: 100% 0;
  }
}

/* RTL */

.qazlatyn-rtl-notifications {
  padding: 10px;
  margin: 0 0 5px 5px;
  font-size: 12px;
  color: #ffffff !important;
  background: #01c0d1 !important;
  border-left: none !important;
  border-right: 5px solid #008490 !important;

  .notification-title,
  .notification-content {
    direction: rtl;
    text-align: right;
  }

  &.warn {
    background: #ffb648 !important;
    border-right-color: #f48a06 !important;
  }

  &.error {
    background: #e54d42 !important;
    border-right-color: #b82e24 !important;
  }

  &.success {
    background: #68cd86 !important;
    border-right-color: #42a85f !important;
  }
}
</style>

<style>
.qazlatyn-app .scroll-to-top {
  position: fixed;
  bottom: 7rem;
  right: 3rem;
  display: flex;
  width: 2.5rem;
  height: 2.5rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  border: 1px solid #008496;
  box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.5);
  background-color: #fefefe;
  opacity: 1;
  transition: opacity 0.7s ease-in;
}
.qazlatyn-app .scroll-to-top .to-top-link {
  font-size: 1.5rem;
  color: #008496;
}

/* Page Loading */

.page-loading {
  height: 3px;
  background: #ffffff;
}
.page-loading .page-loading-bar {
  position: relative;
  width: 100%;
  height: 3px;
  background: #00849055;
}
.page-loading .page-loading-bar::after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 3px;
  background: #008490;
  transform-origin: 0 0;
  transform: scaleX(0);
  animation: loading 1.5s ease infinite;
}

/* RTL */

.rtl-layout .ctrl-dir {
  direction: rtl;
}
.rtl-layout .ctrl-dir * {
  direction: ltr;
}
</style>
